export default "__VITE_ASSET__CCen5gvv__"